// «Нет доступа» (задача D4): раздел не открыт роли вошедшего. Разделы, закрытые роли, в меню не показываются,
// поэтому сюда попадают по прямой ссылке: экран называет роль, кому раздел открыт и кто даёт доступ.
import { ROLE_RU, type Role } from '@contract/index.js';
import { Lock } from 'lucide-react';
import { Link } from 'react-router';
import { buttonVariants } from '@/components/ui/button';
import { StateScreen } from './state-screen';

export interface ForbiddenProps {
  /** Название раздела: «На проверку». */
  readonly titleRu: string;
  /** Роль вошедшего. */
  readonly role: Role;
  /** Кому раздел открыт. */
  readonly allowed: readonly Role[];
}

export function Forbidden({ titleRu, role, allowed }: ForbiddenProps) {
  const roles = allowed.map((r) => `«${ROLE_RU[r]}»`).join(', ');
  return (
    <StateScreen
      icon={Lock}
      title={`Нет доступа к разделу «${titleRu}»`}
      action={
        <Link to="/" className={buttonVariants({ size: 'lg' })}>
          Открыть «Обзор»
        </Link>
      }
    >
      <p>{`Ваша роль — «${ROLE_RU[role]}». Раздел открыт ${allowed.length === 1 ? 'роли' : 'ролям'} ${roles}. Доступ даёт Влад.`}</p>
    </StateScreen>
  );
}
